import config from '../../../config';
import { showErrorMsg } from '../ErrorMsg';

export const socialLoginRedirectUrl = (provider, params = {}) => {

  const queryParams = Object
    .entries(params)
    .map(([key, val]) => `${key}=${val}`);

  return $.get(`${config.localeApi}/sociallogin/${provider}/redirectUrl?${queryParams.join('&')}`)
    .fail(({ responseJSON: { errors = '' } }) => {
      showErrorMsg(errors);
    });
};

export const socialLoginAuthenticate = (provider, data, failedCallback = () => null) =>
  $.post(`${config.localeApi}/sociallogin/${provider}/authenticate`, data)
    .fail(({ responseJSON: { errors = '' } }) => {
      showErrorMsg(errors);
      failedCallback();
    });

export const socialLoginRevoke = (provider, failedCallback = () => null) =>
  $.ajax({
      url: `${config.localeApi}/sociallogin/${provider}/revoke`,
      type: 'DELETE',
    })
    .fail(({ responseJSON: { errors = '' } }) => {
      showErrorMsg(errors);
      failedCallback();
    });

export const socialLoginAuthenticateWithAuthCode = (
  provider,
  authCode,
  checkHasUnlinkedAccount = 0,
  failedCallback = () => null,
) => socialLoginAuthenticate(provider, {
  code: authCode,
  check_has_unlinked_account: checkHasUnlinkedAccount,
}, failedCallback);

export const socialLoginAuthenticateWithAccessToken = (
  provider,
  accessToken,
  tokenExpiresAt,
  refreshToken = '',
  checkHasUnlinkedAccount = 0,
  failedCallback = () => null,
) => socialLoginAuthenticate(provider, {
  access_token: accessToken,
  refresh_token: refreshToken,
  token_expires_at: tokenExpiresAt,
  check_has_unlinked_account: checkHasUnlinkedAccount,
}, failedCallback);



// WEBPACK FOOTER //
// ./src/Common/Providers/SocialLoginApi.js